import { ApiFetchOptions, useApiFetch } from '@/shared';

export type Agent = {
  id: number;
  name: string | null;
  email: string | null;
  phone: string | null;
  address_of_operation?: string | null;
  address_text?: string | null;
  payment_account: string | null;
  payment_bank: string | null;
  bank_bik: string | null;
  bank_ca: string | null;
  card_number: string | null;
  comment: string | null;
  created_at: string;
  inn: string | null;
  kb_percent: number | null;
  legal_form: string | null;
  mortgage_agent: boolean | null;
  sales_points: number[];
  taxation_system: string | null;
  vat_variant_id: number | null;
  user_id: number | null;
};

export type AgentUpdate = {
  id?: number | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  inn?: string | null;
  address_of_operation?: string | null;
  address_text?: string | null;
  bank_bik?: string | null;
  bank_ca?: string | null;
  payment_bank?: string | null;
  payment_account?: string | null;
  bik?: string | null;
  correspondent_account?: string | null;
};

/** Создать/обновить агента */
export const useUpdateAgent = () =>
  useApiFetch<{ _data: AgentUpdate }, Agent>('cabinet/agent/update', {}, 'json');

export const useGetAgentList = () =>
  useApiFetch<ApiFetchOptions, Agent[]>('selfregister/agent/get_list', {}, 'json');

export const useGetAgentById = () =>
  useApiFetch<{ _data: { id: number } }, Agent>('cabinet/agent/get', {}, 'json');
